// Upload now uses the presigned-URL flow (PRESIGN_URL below); the old direct
// faceimageupload endpoint is no longer used.
export const FIND_IMAGES_API_URL = "https://myphotoapi.narendramodi.in/v1/photo/findfacesv2collection";
// export const FIND_IMAGES_API_URL = "http://localhost:8082/v1/photo/findfacesv2collection";
// Presigned-URL endpoint.
// NOTE: myphotoapi.narendramodi.in has an incomplete SSL chain (fails on mobile
// Chrome). nmapi-pp1 has a good cert but its POST response returns a wrong
// Access-Control-Allow-Origin (CORS bug) — reverted here until one of those is fixed.
export const PRESIGN_URL = "https://myphotoapi.narendramodi.in/v1/photo/presignedurlphotobooth";
// export const FIND_IMAGES_API_URL = "https://newdam.nmarchive.in/napi/api/v1/rendition/findfaces";
// export const CDN_URL = "https://d1j81562w5dacu.cloudfront.net/";
export const CDN_URL = "https://myphoto.narendramodi.in/";
// Resize-capable (Akamai Image Manager) CDN. Images are built from the match's
// file_system_path; append ?im=Resize,width=N for a resized variant.
export const VIDEO_CDN = "https://appvideos.narendramodi.in/v2/";
export const facebookShareLink = "https://www.facebook.com/dialog/feed?app_id=445815495479697";
export const twitterShareLink = "https://twitter.com/intent/tweet?text=";
export const whatsappShareLink = "https://api.whatsapp.com/send?text=";
export const DOMAINE_URL = "https://nmphotos.narendramodi.in";